import { Divider, Grid, Typography } from '@mui/material';

import { CalendarIcon } from '../../../iconRef/mealPLanIcons';
import { getCurrentAndFutureDate } from '../../mealPlanPage/utils';
import { CategoryItem } from '../groceryList.types';
import GroceryListCategory from '../groceryListCategory/GroceryListCategory';
import styles from './GroceryListCategories.module.css';

const GroceryListCategories = ({ refetchGrocery }: { refetchGrocery: () => Promise<void> }) => {
    const dateRange = getCurrentAndFutureDate();
  return (
    <Grid className={styles.categories_container}>
       <Grid className={styles.date_range}>
        <CalendarIcon />
        <Typography variant='recipeName'>{`${dateRange.currentDate} - ${dateRange.futureDate}`}</Typography>
      </Grid>
      <GroceryListCategory refetchGrocery={refetchGrocery} />
    </Grid>
  )
}

export default GroceryListCategories
